export const ASSOCIATE_CANDIDATE = "associate_candidate";
